export default "__VITE_ASSET__oxHiezfO__"